import addRoute from '@/router/add-route';
import store from '@/store';

const Login = () => import('@/modules/guest/login.vue');
const ForgotPassword = () => import('@/modules/guest/forgot-password.vue');
const ResetPassword = () => import('@/modules/guest/reset-password.vue');
const Signup = () => import('@/modules/guest/signup.vue');
const Activate = () => import('@/modules/guest/activate.vue');

const guest = [
    addRoute({
        name: 'login',
        component: Login,
        authorized: false,
    }),
    addRoute({
        name: 'logout',
        authorized: false,
        beforeEnter() {
            // When user is logout successfully, redirect to login page after permissions updated.
            store.dispatch('app/logout');
        },
    }),
    addRoute({
        name: 'forgot-password',
        component: ForgotPassword,
        authorized: false,
    }),
    addRoute({
        name: 'signup',
        component: Signup,
        authorized: false,
    }),
    addRoute({
        name: 'activate',
        path: '/activate/:token',
        component: Activate,
        authorized: false,
    }),
    addRoute({
        name: 'reset-password',
        path: '/reset-password/:token',
        component: ResetPassword,
        authorized: false,
    }),
    addRoute({
        name: 'reset-password-redirect',
        path: '/site/resetpassword/:token',
        redirect: '/reset-password/:token',
        authorized: false,
    }),
];

export default guest;
